import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCharts from "vue-chartjs";
import VTooltip from "v-tooltip";
import VueHtmlToPaper from "vue-html-to-paper";
import VueSweetalert2 from "vue-sweetalert2";
import { Datetime } from "vue-datetime";
import VueFuse from "vue-fuse";
import VCalendar from "v-calendar";

Vue.use(VueHtmlToPaper);
Vue.use(VCalendar);

import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VTooltip);
Vue.use(VueCharts);
Vue.use(VueSweetalert2);

import "@/assets/styles/soft-ui-dashboard-tailwind.min.css";

import "@/assets/styles/tailwind.css";




// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
Vue.use(Datetime);
Vue.use(VueFuse);

Vue.config.productionTip = false;

window._ = require("lodash");

const host = window.location.host;
const parts = host.split(".");

Vue.prototype.$hostname = parts[0];
Vue.prototype.$domain = parts[1];
//Vue.prototype.$primaryStyle = true //['primarypepassport'].includes(parts[1])

Vue.prototype.$version = require("../package.json").version;

rg4js("setVersion", Vue.prototype.$version);

if (process.env.NODE_ENV != "development") {
  //raygun error monitor
  Vue.config.errorHandler = function(err, vm, info) {
    rg4js("send", {
      error: err,
      customData: [{ info: info }]
    });
  };
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
